import React, {useState} from "react";

import "./LivelogConnection.css";
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import {faPlug, faPlugCircleXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {forceReload, sleep} from "../../../lib/utils";
import {useAuth} from "../../../contexts/AuthContext";
import config from "../../../config";

window.webskt = null;

function LivelogConnection({setMessages, bondId, setCurrentTab}) {
    const [livelogSocket, setLivelogSocket] = useState(null);
    const [isDisconnecting, setIsDisconnecting] = useState(false);
    const { getToken } = useAuth();

    function getCurrentTimestamp() {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    }

    function connect() {
        setCurrentTab('livelog');
        // Get JWT token from auth context for authentication
        // Falls back to localStorage for backward compatibility
        const token = getToken() || localStorage.getItem(`bondToken-${bondId}`) || '';
        const wsUrl = config.websocket.getPalantirLivelogUrl(bondId, token);
        const webSocket = new WebSocket(wsUrl);

        webSocket.onopen = () => {
            window.api.livelogOn(bondId).then((response) => {
                console.log("Livelog Connected.");
            });
        };

        webSocket.onmessage = (event) => {
            const message = event.data;
            console.log(message);

            setMessages((prevMessages) => {
                return Array.isArray(prevMessages) ? [...prevMessages, [getCurrentTimestamp(), message]] : [[getCurrentTimestamp(), message]];
            });
        };

        webSocket.onerror = (error) => {
            console.error("WebSocket error:", error);
            disconnect();
        };

        webSocket.onclose = () => {
            console.log("Livelog closed");
            disconnect();
        };
        window.webskt = webSocket;
        setLivelogSocket(webSocket);
    }

    async function disconnect() {
        // Prevent multiple simultaneous disconnections
        if (isDisconnecting) {
            console.log('Already disconnecting, skipping...');
            return;
        }

        setIsDisconnecting(true);

        try {
            if (window.api) {
                let response = await window.api.livelogOff(bondId);
                if (response.status === 403) {
                    forceReload();
                    await sleep(5000);
                }
            }

            // Close WebSocket
            if (livelogSocket) {
                livelogSocket.close();
            }

            setLivelogSocket(null);
        } catch (error) {
            console.error('Error during disconnect:', error);
        } finally {
            setIsDisconnecting(false);
        }
    }

    return (<Col xs="12" className="text-center">
        {!livelogSocket ? <Button className="btnConnect" variant="primary" onClick={connect}><FontAwesomeIcon
                icon={faPlug}/> CONNECT</Button> :
            <Button className="btnConnect" variant="danger" onClick={disconnect}><FontAwesomeIcon
                icon={faPlugCircleXmark}/> DISCONNECT</Button>}
    </Col>);
}

export default LivelogConnection;


